import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { IConfigComponent, CEntity } from '@ts/ui-models';
import { generateGlobalColumns, Grid, IDataGridConfig } from '@ts/storybook';
import { Box, Tooltip } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

interface IKpiOperationTypeProps {
  configComponent: IConfigComponent;
  inheritedProps: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'kpiOperationTypes',
  aclId: 'KpiOpType',
  entity: 'kpiOperationTypes',
  fetchURL: '/api/v2/kpiOperationTypes',
};

const KpiOperationType = (props: IKpiOperationTypeProps) => {
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };

  const getColumns = (): GridColDef[] => {
    const globalCells = generateGlobalColumns(props);
    return [
      globalCells.id(),
      {
        headerName: 'Name',
        field: 'name',
        valueGetter: (value, row, column) => {
          return new CEntity(row).getName();
        },
        renderCell: (params: GridRenderCellParams) => {
          const entity: any = new CEntity(params.row);
          return (
            <Box>
              <Grid container alignItems="center" spacing={1}>
                <Grid>{entity.getName()}</Grid>
                {entity.description && (
                  <Grid sx={{ marginTop: '4px' }}>
                    <Tooltip title={entity.description}>
                      <InfoOutlined fontSize="small" />
                    </Tooltip>
                  </Grid>
                )}
              </Grid>
            </Box>
          );
        },
      },
    ];
  };

  return (
    <WrapperDataGrid
      configComponent={props.configComponent}
      dataGridConfig={config}
      columns={getColumns()}
      rowHeight={40}
      //Extra data
      inheritedProps={props.inheritedProps}
    />
  );
};

export default KpiOperationType;
